<template>
    <v-autocomplete
    v-model="localSelectedID"
    :items="items"
    :search-input.sync="search"
    :filter="customFilter"
    item-text="name"
    item-value="id"
    placeholder="Search..."
    hide-details
    color="color1"
    spellcheck="false"
    solo
    :clearable="clearable">

    <template
    slot="selectionn"
    slot-scope="{ item, selected }">
      <div style="display: flex;flex-wrap:nowrap;align-items:center;">
        <v-list-item-avatar
        size="30px"
        color="teal accent-3"
        class="headline font-weight-light white--text">
          {{ item.name.charAt(0) }}
        </v-list-item-avatar>
        <span class="blue-grey--text">
          {{ item.name }}
        </span>
      </div>
    </template>

    <template 
    slot="no-data">
      <v-list-item>
        <v-list-item-title>
          No matching
          <strong>customers</strong>
        </v-list-item-title>
      </v-list-item>
    </template>

    <template
    slot="item"
    slot-scope="{ item }">

    <v-list-item-avatar
    color="color1 accent-3"
    class="headline font-weight-light white--text">
      {{ item.name.charAt(0) }}
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title v-html="highlight(item.name)"></v-list-item-title>
    </v-list-item-content>

    </template>

    </v-autocomplete>
</template>

<script>

export default {
  props: {
    selectedID: null,
    clearable: false
  },
  data () {
    return {
      search: '',
      items: [],
      isLoading: false
    }
  },
  watch: {
    search (val) {
      // Items have already been loaded
      // if (this.items.length > 0) return

      // Lazily load input items
      this.fetchAPI()
    },
    selectedID (nv) {
    }
  },
  computed: {
    keywords () {
      return (this.search || '').toLowerCase().split(' ')
    },
    localSelectedID: {
      get () {
        return this.selectedID
      },
      set (nv) {
        this.$emit('update:selectedID', nv)
        this.$emit('change', this.items.find(item => item.id === nv))
      }
    }
  },
  methods: {
    fetchAPI () {
      var filters = {
        search: this.search,
        selectedID: this.selectedID
      }
      const encodedFilters = btoa(JSON.stringify(filters))
      this.isLoading = true
      this.$axios.get('/suppliers/autocomplete?filters=' + encodedFilters)
        .then(response => {
          var rows = response.data.rows
          this.count = response.data.count
          this.items = rows //.filter(item => item.complete === 0)
        })
        .catch(error => console.log(error))
        .then(() => this.isLoading = false)
    },
    customFilter (item, queryText, itemText) {
      return this.keywords.every(keyword => {
        return (item.name).toLowerCase().indexOf(keyword) > -1
      })
    },
    highlight (str) {
      var replacedStr = (this.search || '').trim().split(/\s+/).map(x => x.replace(/[-[\]{}()*+!<=:?.\\^$|#\s,]/g, '\\$&')).join('|')
      replacedStr = str.replace(new RegExp(replacedStr, 'gi'), '<span class="font-weight-regular">$&</span>')
      if (!this.search) {
        return replacedStr
      }
      return '<span class="font-weight-bold">' + replacedStr + '</span>'
    }
  }
}
</script>

